import { API_CONFIG } from '../lib/apiConfig';
import { createPngMetaOverlayHook } from '../lib/hookFactories';

/**
 * Finds the precomputed Forest Ownership PNG overlay + geographic bounds for
 * (mill, drive_time). The hook only fetches the small `.meta.json` sidecar;
 * Leaflet's ImageOverlay loads the PNG bytes itself when rendered.
 */
export const useFoOverlay = createPngMetaOverlayHook({
  metaPath: API_CONFIG.s3.paths.foOverlayMeta,
  pngPath: API_CONFIG.s3.paths.foOverlay,
});
